<div class="mt-6 flex flex-col md:flex-row md:items-start">
  <div class="flex-auto">
    <div class="card mt-6">
      <base-data-table-header
        [label]="entityName"
        [loading]="loadingData"
        [showArchives]="false"
        (onSearchChange)="onSearchChange($event)"
        (onClearTextFilter)="clearTextFilter()"
        (onCreate)="addClientNumber()"
        (onImport)="importItem()"
        [canImport]="true"
        [createPermission]="ENUM_PERMISSION.CREATE_SUPPLIER"
        [showSearch]="false"
        [backgroundColorWhite]="true"
        [importPermission]="[ENUM_PERMISSION.UPDATE_SUPPLIER]"
      ></base-data-table-header>

      <base-data-table
        [count]="count"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [sortField]="sortField"
        [sortOrder]="sortOrder"
        (onPageEvent)="pageEvent($event)"
        (onSortEvent)="sortEvent($event)"
        (onUpdateItem)="updateClientNumber($event)"
        (onDeleteItem)="deleteClientNumber($event)"
        (onArchiveItem)="archiveItem($event)"
        [dataSource]="dataSourceCode"
        [displayedColumns]="displayedColumnsCode"
        [feisColumns]="feisColumns"
        [showPaginator]="false"
        [showSort]="false"
      ></base-data-table>
    </div>
  </div>
</div>
